export enum LiveWorkloadTab {
  AGENTS = 'agents',
  DEPARTMENTS = 'departments'
}
